import { render, staticRenderFns } from "./Tasks.vue?vue&type=template&id=4860b9d6&"
import script from "./Tasks.js?vue&type=script&lang=js&"
export * from "./Tasks.js?vue&type=script&lang=js&"
import style0 from "./Tasks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports